import React, { useMemo } from "react";
import PropTypes from "prop-types";

import ReactTable from "react-table";

import Loading from "../../common/Loading";

import {
  SUPPORT_TICKET_DETAIL_COLUMNS,
  SUPPORT_TICKET_DETAIL_SUB_COLUMNS
} from "./columns";

import "./SupportTicketDetailList.scss";

const SupportTicketDetailList = ({
  data,
  loading,
  onPageSizeChange,
  defaultPageSize,
  onPageChange,
  page,
  pageSize,
  count
}) => {
  const defaultExpanded = useMemo(() => {
    const allExpanded = {};
    data.forEach((row, index) => {
      allExpanded[index] = true;
    });
    return allExpanded;
  }, [data]);

  if (loading)
    return (
      <div className="loading">
        <Loading />
      </div>
    );

  if (!data || !data.length) {
    return (
      <div className="loading">
        <h4 style={{ opacity: 0.15 }}>No Data</h4>
      </div>
    );
  }

  return (
    <React.Fragment>
      <div
        className="content-wrapper"
        style={{ padding: "15px 15px ", borderRadius: "0.5rem" }}
      >
        <ReactTable
          manual
          showPageSizeOptions
          showPagination
          className="tickets-table"
          getTheadProps={() => ({
            style: {
              borderRadius: "0.5rem",
              fontWeight: "bold"
            }
          })}
          getTrProps={(state, rowInfo) => {
            if (rowInfo && rowInfo.row) {
              return {
                style: {
                  backgroundColor: "#50accb",
                  color: "#f2f3f8",
                  fontWeight: "bold"
                }
              };
            }
            return {};
          }}
          columns={SUPPORT_TICKET_DETAIL_COLUMNS}
          data={data}
          defaultPageSize={defaultPageSize}
          noDataText="No tickets found"
          pageSize={Math.min(pageSize)}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
          pages={Math.ceil(count / pageSize)}
          page={page}
          defaultExpanded={defaultExpanded}
          SubComponent={({ original }) => (
            <div className="calls-container">
              <div
                style={{
                  padding: "15px",
                  backgroundColor: "rgba(80, 172, 203, 0.2)"
                }}
              >
                <div className="details-row">
                  {original.request_nature_details}
                </div>
              </div>

              <ReactTable
                className="calls-table"
                data={original.calls}
                columns={SUPPORT_TICKET_DETAIL_SUB_COLUMNS}
                showPagination={false}
                showPageSizeOptions={false}
                pageSize={original.calls.length}
              />
            </div>
          )}
        />
      </div>
    </React.Fragment>
  );
};

SupportTicketDetailList.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool,
  defaultPageSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onPageSizeChange: PropTypes.func,
  onPageChange: PropTypes.func,
  page: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  pageSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  count: PropTypes.number
};

SupportTicketDetailList.defaultProps = {
  data: []
};

export default SupportTicketDetailList;
